import base from './base'
import axios from '@/core/request/http'

const user = {
    me() {
        return axios.get(`${base.user}/me`);
    }
}

export default user;